.work {
  display: grid;
  gap: var(--space-3);
  width: 100%;
  max-width: 100%;
  min-width: 0;
  color: var(--color-text-primary);
}

.header,
.headerActions,
.detailHeader,
.detailActions,
.cardHeader,
.cardMeta,
.cardFooter,
.row,
.rowHeader,
.dialogHeader,
.filterActions {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.header {
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: var(--space-3);
}

.header h1,
.header p,
.detailHeader h2,
.detailHeader p,
.column h2,
.mobileGroup h2,
.dialogHeader h2,
.descriptionPreview h3,
.activity h3 {
  margin: 0;
}

.header h1 {
  max-width: 24ch;
  color: var(--color-text-primary);
  font-size: clamp(1.75rem, 3vw, 2.5rem);
  line-height: 1.08;
  letter-spacing: -0.045em;
  overflow-wrap: anywhere;
}

.subtitle {
  max-width: 62ch;
  margin-block-start: 6px !important;
  color: var(--color-text-secondary);
}

.state,
.columnEmpty,
.mobileGroup p,
.dropHint,
.cardMeta,
.cardFooter,
.labels,
.liveRegion,
.activity time,
.timelineItem time {
  color: var(--color-text-secondary);
}
.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  padding: var(--space-2);
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-control);
  background: var(--color-recessed);
}

.pagination p {
  margin: 0;
  color: var(--color-text-secondary);
}

.eyebrow {
  margin: 0 0 6px;
  color: var(--color-text-tertiary);
  font-size: 0.6875rem;
  font-weight: 800;
  letter-spacing: 0.085em;
  text-transform: uppercase;
}

.headerActions {
  align-items: flex-end;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.headerActions button,
.primaryButton,
.secondaryButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
}

.toolbar {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(190px, auto);
  align-items: end;
  gap: var(--space-2);
  min-width: 0;
}

.filterControls {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(150px, 180px);
  align-items: end;
  gap: var(--space-1);
}

.taskTools {
  min-width: 0;
}

.taskTools > summary {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: var(--target-min);
  padding-inline: var(--space-2);
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  background: var(--color-surface);
  color: var(--color-text-primary);
  cursor: pointer;
  font-weight: 650;
  list-style: none;
}

.taskTools > summary::-webkit-details-marker {
  display: none;
}

.taskTools[open] > summary {
  border-color: var(--color-accent);
  background: var(--color-accent-subtle);
  color: var(--color-accent);
}

.taskToolsPanel {
  display: grid;
  gap: var(--space-1);
  margin-top: var(--space-1);
  padding: var(--space-1);
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-control);
  background: var(--color-surface);
}

.filterActions {
  flex-wrap: wrap;
  justify-content: flex-end;
}

.searchField,
.compactField,
.quickCreate label,
.createProject label,
.detailForm label,
.activity form,
.moveMenu,
.rowMove {
  display: grid;
  gap: 5px;
}

.searchField,
.compactField,
.quickCreate label {
  min-width: 0;
}

.searchField span,
.compactField span,
.quickCreate span,
.createProject span,
.detailForm span,
.moveMenu > span,
.rowMove > span {
  color: var(--color-text-tertiary);
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.035em;
}

.work input,
.work textarea,
.work select,
.work button {
  min-height: var(--target-min);
  font: inherit;
}

.work input,
.work textarea,
.work select {
  min-width: 0;
  padding: 0 12px;
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  background: var(--color-surface);
  color: var(--color-text-primary);
}

.work input::placeholder,
.work textarea::placeholder {
  color: var(--color-text-tertiary);
}

.work input:hover,
.work textarea:hover,
.work select:hover {
  border-color: var(--color-text-tertiary);
}
.checkboxField {
  display: flex !important;
  align-items: center;
  gap: var(--space-1);
  min-height: var(--target-min);
}

.checkboxField input {
  flex: 0 0 auto;
  width: var(--space-2);
  min-width: var(--space-2);
  height: var(--space-2);
  min-height: var(--space-2);
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  accent-color: var(--color-accent);
}

.checkboxField span {
  color: var(--color-text-primary);
  font-size: inherit;
  font-weight: 650;
  letter-spacing: normal;
}

.work textarea {
  padding-block: var(--space-2);
  resize: vertical;
}

.work button {
  padding: 0 var(--space-2);
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  cursor: pointer;
}

.work button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.primaryButton {
  border-color: var(--color-accent) !important;
  background: var(--color-accent);
  color: var(--color-action-inverse-text);
  font-weight: 750;
}

.primaryButton:hover:not(:disabled) {
  background: var(--color-accent-hover);
}

.secondaryButton {
  background: var(--color-surface);
  color: var(--color-text-primary);
  font-weight: 650;
}

.secondaryButton:hover,
.secondaryButton[aria-pressed="true"] {
  border-color: var(--color-accent);
  background: var(--color-accent-subtle);
  color: var(--color-accent);
}

.work button:focus-visible,
.work input:focus-visible,
.work textarea:focus-visible,
.work select:focus-visible {
  outline-color: var(--focus-outline-color);
  box-shadow: var(--focus-keyline);
}

.quickCreate {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(130px, 160px) auto;
  align-items: end;
  gap: var(--space-1);
  min-width: 0;
}

.createProject,
.detailForm,
.descriptionPreview,
.activity {
  display: grid;
  gap: var(--space-2);
}
.detailFieldset {
  display: grid;
  gap: var(--space-2);
  min-inline-size: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.projectDialog {
  width: min(480px, calc(100vw - var(--space-3)));
  max-width: none;
  padding: 0;
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-overlay);
  background: var(--color-surface);
  color: var(--color-text-body);
  box-shadow: var(--shadow-overlay);
}

.projectDialog::backdrop {
  background: rgb(23 26 43 / 38%);
}

.createProject {
  padding: var(--space-3);
}

.dialogHeader {
  align-items: flex-start;
  justify-content: space-between;
}

.projectDialogActions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-1);
}

.board {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding-bottom: var(--space-1);
}

.column {
  display: grid;
  grid-template-rows: auto 1fr;
  min-width: 0;
  min-height: 480px;
  padding: 10px;
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-surface);
  background: var(--color-recessed);
}

.column header {
  display: grid;
  gap: 5px;
  padding: 4px 4px 12px;
}

.column h2,
.mobileGroup h2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-1);
  font-size: 0.9rem;
  letter-spacing: -0.01em;
}

.column h2 span:last-child,
.mobileGroup h2 span:last-child {
  display: grid;
  place-items: center;
  min-width: 24px;
  height: 24px;
  padding-inline: 6px;
  border-radius: 999px;
  background: var(--color-surface);
  color: var(--color-text-secondary);
  font-size: 0.75rem;
  font-variant-numeric: tabular-nums;
}

.cards {
  display: grid;
  align-content: start;
  gap: 10px;
}

.card {
  display: grid;
  gap: 10px;
  min-width: 0;
  padding: 12px;
  border: 1px solid var(--color-hairline);
  border-radius: 12px;
  background: var(--color-surface);
  box-shadow: 0 1px 2px rgb(23 26 43 / 4%);
}

.card:hover {
  border-color: var(--color-boundary);
  box-shadow: var(--shadow-surface);
}

.card[data-moving="true"],
.row[data-moving="true"] {
  border-color: var(--color-accent);
  background: var(--color-accent-subtle);
}

.cardHeader,
.rowHeader {
  align-items: flex-start;
  min-width: 0;
  gap: 8px;
}

.dragHandle {
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  min-width: var(--target-min);
  width: var(--target-min);
  padding: 0 !important;
  border-color: transparent !important;
  background: transparent;
  color: var(--color-text-tertiary);
  touch-action: none;
}

.dragHandle:hover {
  background: var(--color-surface-raised);
  color: var(--color-accent);
}

.cardTitle,
.rowTitle {
  flex: 1 1 auto;
  min-width: 0;
  min-height: var(--target-min);
  padding: 8px 0 !important;
  border: 0 !important;
  background: transparent !important;
  color: var(--color-text-primary);
  text-align: start;
  font-weight: 720;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.cardTitle:hover,
.rowTitle:hover {
  color: var(--color-accent);
}

.cardMeta,
.cardFooter {
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 6px 10px;
  font-size: 0.75rem;
}

.cardMeta span,
.cardFooter span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.cardMeta span:first-child {
  min-height: 24px;
  padding-inline: 8px;
  border-radius: 999px;
  background: var(--color-recessed);
  font-weight: 700;
}

.cardMeta span[data-priority="urgent"] {
  background: var(--color-danger-subtle);
  color: var(--color-danger);
}

.cardMeta span[data-priority="high"] {
  background: var(--color-warning-subtle);
  color: var(--color-warning);
}

.labels {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin: 0;
}

.labels span {
  padding: 3px 7px;
  border-radius: 6px;
  background: var(--color-recessed);
  color: var(--color-text-secondary);
  font-size: 0.72rem;
  overflow-wrap: anywhere;
}

.moveMenu {
  margin-top: 2px;
  padding-top: 10px;
  border-top: 1px solid var(--color-hairline);
}

.moveMenu select,
.rowMove select {
  width: 100%;
  min-height: var(--target-min);
  background: var(--color-surface-raised);
  font-size: 0.82rem;
}

.moveActions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1);
}

.row .moveActions {
  grid-column: 1 / -1;
}

.dropHint {
  font-size: 0.7rem;
}

.columnEmpty {
  margin: 0;
  padding: var(--space-2) 4px;
  font-size: 0.82rem;
}

.desktopList {
  display: none;
  gap: var(--space-2);
}

.mobileGroup {
  display: grid;
  gap: var(--space-1);
  padding: var(--space-2);
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-surface);
  background: var(--color-surface);
  box-shadow: var(--shadow-surface);
}

.desktopList[data-visible-on-desktop="true"] {
  display: grid;
}

.empty {
  display: grid;
  gap: var(--space-2);
  padding: var(--space-3);
}

.error {
  padding: var(--space-2);
  border: 1px solid var(--color-danger);
  border-radius: var(--radius-control);
  background: var(--color-danger-subtle);
  color: var(--color-danger);
}

.liveRegion {
  min-height: 1.5rem;
}

.row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto minmax(150px, 190px);
  align-items: center;
  padding: var(--space-1) 0;
  border-top: 1px solid var(--color-hairline);
}

.rowHeader {
  min-width: 0;
}

.rowTitle {
  display: block;
}

.rowMove {
  min-width: 0;
}

.detail {
  position: fixed;
  z-index: 10;
  inset: 0 0 0 auto;
  display: grid;
  align-content: start;
  gap: var(--space-3);
  width: min(560px, 100vw);
  min-width: 0;
  overflow-y: auto;
  padding: var(--space-3);
  border-left: 1px solid var(--color-boundary);
  background: var(--color-surface);
  box-shadow: var(--shadow-overlay);
}

.detailHeader {
  justify-content: space-between;
  align-items: flex-start;
}

.detailHeader h2 {
  overflow-wrap: anywhere;
}
.detailStatus {
  margin: 0;
  padding: var(--space-1) var(--space-2);
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-control);
  background: var(--color-recessed);
  color: var(--color-text-secondary);
}

.detailStatus[data-state="unsaved"],
.detailStatus[data-state="saving"] {
  border-color: var(--color-accent);
  color: var(--color-accent);
}

.detailStatus[data-state="stale"],
.detailStatus[data-state="forbidden"] {
  border-color: var(--color-danger);
  color: var(--color-danger);
}

.statusMove {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: var(--space-2);
  padding-block-end: var(--space-2);
  border-bottom: 1px solid var(--color-hairline);
}

.statusMove label {
  display: grid;
  flex: 1 1 180px;
  gap: 5px;
}

.statusMove span,
.readOnlyDetails strong {
  color: var(--color-text-secondary);
  font-size: 0.8rem;
}

.readOnlyDetails {
  display: grid;
  gap: var(--space-1);
  padding: var(--space-2);
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-control);
  background: var(--color-recessed);
}

.readOnlyDetails p {
  margin: 0;
}


.formGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-2);
}

.detailActions {
  flex-wrap: wrap;
}

.descriptionPreview,
.activity {
  padding-top: var(--space-2);
  border-top: 1px solid var(--color-hairline);
}

.markdown {
  overflow-wrap: anywhere;
  line-height: 1.55;
}

.markdown p {
  margin: 0 0 var(--space-1);
  white-space: pre-wrap;
}

.activity form {
  align-items: stretch;
}

.timeline {
  display: grid;
  gap: var(--space-2);
}

.timelineItem,
.activityItem {
  display: grid;
  gap: var(--space-1);
  padding: var(--space-2);
  border-inline-start: 3px solid var(--color-accent);
  border-radius: 0 var(--radius-control) var(--radius-control) 0;
  background: var(--color-surface-raised);
}

.timelineItem p {
  margin: 0 0 var(--space-1);
  overflow-wrap: anywhere;
}

.activityItem {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 1250px) {
  .board {
    grid-template-columns: repeat(5, minmax(220px, 1fr));
    overflow-x: auto;
  }

  .desktopList[data-visible-on-desktop="true"] {
    display: grid;
  }
}

@media (max-width: 1050px) {
  .toolbar {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 700px) {
  .header {
    align-items: stretch;
    flex-direction: column;
  }

  .headerActions {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    align-items: stretch;
    width: 100%;
    gap: var(--space-1);
  }

  .headerActions > .compactField,
  .headerActions > button {
    grid-column: 1;
  }

  .headerActions button {
    width: 100%;
  }

  .toolbar {
    grid-template-columns: 1fr;
  }

  .quickCreate {
    grid-row: 1;
    grid-template-columns: minmax(0, 1fr) 112px var(--target-min);
  }

  .filterControls {
    grid-template-columns: minmax(0, 1fr) 124px;
  }

  .taskToolsPanel {
    padding-inline: 0;
    border: 0;
    background: transparent;
  }
  .filterActions {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
  }

  .filterActions .secondaryButton {
    width: 100%;
  }

  .quickCreate > * {
    width: 100%;
  }

  .quickCreate .primaryButton {
    width: auto;
    min-width: max-content;
    padding-inline: var(--space-2);
    font-size: inherit;
  }

  .board {
    grid-template-columns: repeat(5, minmax(220px, 1fr));
    overflow-x: auto;
  }

  .desktopList[data-visible-on-desktop="true"] {
    display: grid;
  }

  .row {
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
  }

  .rowHeader {
    grid-column: 1 / -1;
  }

  .rowMove {
    grid-column: 1 / -1;
  }

  .detail {
    inset: 0;
    width: 100%;
    min-height: 100dvh;
    border: 0;
    border-radius: 0;
  }

  .formGrid {
    grid-template-columns: 1fr;
  }
  .projectDialog {
    width: calc(100vw - var(--space-2));
    margin: auto var(--space-1);
  }
}

@media (min-width: 701px) {
  .detail {
    top: var(--space-2);
    bottom: var(--space-2);
    right: var(--space-2);
    border: 1px solid var(--color-hairline);
    border-radius: var(--radius-surface);
  }
}
